<template>
  <v-main class="validar-cambio-email fill-height d-flex flex-column align-center justify-center pa-8">
    <v-progress-circular indeterminate color="primary" size="48" width="4" />
    <p class="text-body-2 text-medium-emphasis text-center mt-4">
      Verificando su nuevo correo electrónico…
    </p>
  </v-main>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ValidarCambioEmailView',
  mounted() {
    this.run()
  },
  methods: {
    ...mapActions({
      confirmarCambioEmail: 'auth/confirmarCambioEmail',
    }),
    async run() {
      const q = this.$route.query || {}
      const userId = q.userId ?? q.userid
      const rawToken = q.token ?? q.code
      const newEmailRaw = q.newEmail ?? q.newemail
      const token = rawToken != null && rawToken !== '' ? String(rawToken) : ''
      const newEmail = newEmailRaw != null && newEmailRaw !== '' ? String(newEmailRaw) : ''

      if (!userId || !token || !newEmail) {
        await this.$router.replace({ path: '/patientdata', query: { verificacionEmail: 'error' } })
        return
      }

      const result = await this.confirmarCambioEmail({
        userId: String(userId),
        newEmail: String(newEmail).trim(),
        token,
      })

      if (result?.ok) {
        await this.$router.replace({ path: '/patientdata', query: { verificacionEmail: 'ok' } })
        return
      }

      await this.$router.replace({ path: '/patientdata', query: { verificacionEmail: 'error' } })
    },
  },
}
</script>

<style scoped>
.validar-cambio-email {
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
}
</style>
